import every from 'lodash/every';
import get from 'lodash/get';

export default systemUndermaintenanceMap => offer => every(get(offer, 'systemsList', []).map(system => !systemUndermaintenanceMap[system]));
